import { AgencyService } from './../api/agency.service';
import { Component, OnInit, Injector, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApartmentType, PropertySearch, AdvancedLimits } from '../models/index';
import { AbstractApartmentTypeSearch } from './shared/index';
import { DOCUMENT } from '@angular/platform-browser';

@Component({
  selector: 'app-houses-base',
  template: ''
})

export class ApartmentTypesBaseComponent extends AbstractApartmentTypeSearch implements OnInit {
  apartmentTypes: ApartmentType[] = [];
  callInProgress: boolean;
  advancedLimits: AdvancedLimits;
  routePropertySearch: PropertySearch;

  constructor(
    injector: Injector,
    public agencyService: AgencyService,
    public route: ActivatedRoute,
    @Inject('WINDOW') public window: any,
    @Inject(DOCUMENT) public document: any
  ) {
    super(injector, window);
  }

  ngOnInit(): void {
    this.apiLoading = true;

    this.route.data.forEach((data: any) => {
      if (data.advanced_limits)
        this.advancedLimits = data.advanced_limits;

      if (data.property_search)
        this.routePropertySearch = data.property_search;

      AbstractApartmentTypeSearch.propertySearch = new PropertySearch();
    });

    this.subscription.add(this.route.queryParams
      .subscribe(params => {
        this.validateRouteQueryParams(params);
        AbstractApartmentTypeSearch.propertySearch = this.apartmentTypeService.decodeUrlParams(params, this.advancedLimits);

        if (this.routePropertySearch)
          for (const field in this.routePropertySearch)
            if (this.routePropertySearch.hasOwnProperty(field)
              && this.routePropertySearch[field]
              && field.length
              && AbstractApartmentTypeSearch.propertySearch.hasOwnProperty(field)
              && AbstractApartmentTypeSearch.propertySearch[field] === null)
              AbstractApartmentTypeSearch.propertySearch[field] = this.routePropertySearch[field];

        this.refreshApartmentTypes();
      }));

    this.setTitle('Locuinte ' + this.agencyService.agency.name);
  }

  updatePropertySearch(fieldName: string, fieldValue: number): void {
    AbstractApartmentTypeSearch.propertySearch[fieldName] = fieldValue;
    this.refreshApartmentTypes();
  }

  getCurrentScrollPosition(): number {
    return Math.max(this.document.body.scrollTop, this.document.documentElement.scrollTop);
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/apartment-types-base.component.ts